import React, { useState } from 'react';
import Verificacion from '../verificacion/verificacion';
import VerificacionCodigo from '../verificacionCodigo/verificacionCodigo';
import ConfirmacionForm from '../confirmacionForm/confirmacionForm';
import ConfirmacionEdit from '../corfirmacionEdit/confirmacionEdit';
import ErrorPage from '../errorPage/errorPage';
import { CONTENT_PAG } from '../../constants/content_pag';

const ConfirmacionDev = ({mostrarPolizaMensaje, descripcion1, descripcion2, nombreMonto, descInfo, descripcion1Edit, descripcion2Edit, nombreMontoEdit, descInfoEdit, descripcionVerificacion}) => {
    
    const [ formularioEdicion, mostrarFormularioEdicion ] = useState(CONTENT_PAG.PAG_CONF);
 
    const mostrarPagina = () => {
        switch(formularioEdicion) {
            case CONTENT_PAG.PAG_CONF  : return <ConfirmacionForm  
                                descripcion1={descripcion1}
                                descripcion2={descripcion2}
                                nombreMonto={nombreMonto}
                                descInfo={descInfo}
                                mostrarFormularioEdicion={mostrarFormularioEdicion}
                            />;
            case CONTENT_PAG.PAG_EDIT  : return <ConfirmacionEdit  
                                descripcion1Edit={descripcion1Edit}
                                descripcion2Edit={descripcion2Edit}
                                nombreMontoEdit={nombreMontoEdit}
                                descInfoEdit={descInfoEdit}
                                mostrarFormularioEdicion={mostrarFormularioEdicion}/>;
            case CONTENT_PAG.PAG_VERI  : return <Verificacion      mostrarFormularioEdicion={mostrarFormularioEdicion}/>;
            case CONTENT_PAG.PAG_VERC  : return <VerificacionCodigo 
                                mostrarFormularioEdicion={mostrarFormularioEdicion}
                                descripcionVerificacion={descripcionVerificacion}
                                mostrarPolizaMensaje={mostrarPolizaMensaje}/>
            case CONTENT_PAG.PAG_ERRO  : return <ErrorPage /> 
            default : return <h1>Pagina en construcción</h1>
        }
    }

    return (
        <div>
            { mostrarPagina() }
        </div>
    );
};

export default ConfirmacionDev;
